import { Button } from "@progress/kendo-react-buttons";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { MaskedTextBox, MaskedTextBoxProps } from "@progress/kendo-react-inputs";
import { Dispatch, SetStateAction, useState } from "react";
import { protectedResources } from "../../authConfig";
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { useNotificationAPI } from '../../components/NotificationProvider';
import { kitSizes, padKitNumber, padLotNumber } from "../../models/kit";

interface GenerateLegacyKitSerialNumberProps {
    setSerialNumber: Dispatch<SetStateAction<string>>,
    closeWindow: Function,
    children?: React.ReactNode
}

const pageTitle = 'Generate Legacy Barcode';

const GenerateLegacyKitSerialNumber = (props: GenerateLegacyKitSerialNumberProps) => {
    const { addNotification } = useNotificationAPI();
    const { isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });
    const [lotNumber, setLotNumber] = useState('');
    const [kitSize, setKitSize] = useState(kitSizes[1]);

    const kitSizeChange = (e: DropDownListChangeEvent) => {
        setKitSize(e.value);
    }

    const generateLegacyKitNumber = () => {
        if (kitSize.id === 0) {
            addNotification('Please enter a valid kit vial size', pageTitle, 'info');
            return;
        }
        if (isNaN(Number.parseInt(lotNumber)) || lotNumber.indexOf('_') !== -1) {
            addNotification('Please enter a valid Lot Number', pageTitle, 'info');
            return;
        }
        execute('POST', protectedResources.apiKit.endpoint + "GenerateLegacyKit", {
            LotNumber: lotNumber,
            KitSize: kitSize.id
        })
            .then(
                ((result: any) => {
                    if (result?.id) {
                        addNotification('Barcode Number Genererated successfully', pageTitle, 'success');
                        props.setSerialNumber(padLotNumber(result.lotNumber) + '-' + kitSizes[result.kitSize].shortText + '-' + padKitNumber(result.kitNumber));
                        props.closeWindow();
                    }
                })
            );
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <div>
                        Lot Number:<br></br>
                        <MaskedTextBox mask="0000" defaultValue="0000" value={lotNumber} onChange={(e: MaskedTextBoxProps) => { setLotNumber(e.value as string) }}></MaskedTextBox>
                    </div>
                    <div>
                        Kit Size:<br></br>
                        <DropDownList dataItemKey={"id"} value={kitSize} textField={"text"} data={[kitSizes[1], kitSizes[2]]} onChange={kitSizeChange} title={'Kit Size'}></DropDownList>
                    </div>
                    <br></br>
                    <Button disabled={isLoading} onClick={generateLegacyKitNumber}>Generate Barcode</Button>
                </div>
            </div>
        </div>
    );
}

export default GenerateLegacyKitSerialNumber;